export function setCacheValue(state, cacheKey, value) {
  Object.defineProperty(state, cacheKey, { enumerable: false, value })
  state.__computationsLeft__--
  if (state.__computationsLeft__ === 0)
    delete state.__previous__
}

export function computeValueAndDependencies(state, getters, computedCacheKey, fn) {
  const updatedBy = {}
  const discoveryProxy = Object
    .keys(state)
    .concat(getters)
    .reduce((acc, it) => {
      Object.defineProperty(acc, it, {
        get: () => {
          updatedBy[ it ] = true
          return state[ it ]
        }
      })
      return acc
    }, {})

  setCacheValue(state, computedCacheKey, fn.call(discoveryProxy, discoveryProxy))
  fn.__updatedBy__ = Object.keys(updatedBy)
  return state[ computedCacheKey ]
}

export function createMemoizedGetter(name, getters, fn) {
  const cacheKey = '@@' + name
  const gettersKeys = Object.keys(getters)

  return function () {
    if (!fn.hasOwnProperty('__updatedBy__'))
      return computeValueAndDependencies(this, gettersKeys, cacheKey, fn)

    const didNotComputeYet = !this.hasOwnProperty(cacheKey)
    const shouldCompute = didNotComputeYet && (
      !this.hasOwnProperty('__previous__')
      || fn.__updatedBy__.length === 0
      || fn.__updatedBy__.some(key => this[ key ] !== this[ '__previous__' ][ key ])
    )

    if (shouldCompute)
      setCacheValue(this, cacheKey, fn.call(this, this))
    else if (didNotComputeYet)
      setCacheValue(this, cacheKey, this[ '__previous__' ][ name ])

    return this[ cacheKey ]
  }
}

export function createCopier(numberOfGetters) {
  return function (newValues = {}) {
    const newState = Object.assign({}, this, newValues)
    Object.defineProperties(newState, {
      __previous__: { enumerable: false, writable: false, configurable: true, value: this },
      __computationsLeft__: { enumerable: false, writable: true, value: numberOfGetters }
    })
    newState.__proto__ = this.__proto__
    return newState
  }
}

export function groupShapeElements(shape) {
  return Object.keys(shape).reduce((acc, it) => {
    if (typeof shape[ it ] === 'function')
      acc.getters[ it ] = shape[ it ]
    else
      acc.initialState[ it ] = shape[ it ]
    return acc
  }, { initialState: {}, getters: {} })
}

export function createState(shape) {
  const { initialState, getters } = groupShapeElements(shape)
  const numberOfGetters = Object.keys(getters).length

  const proto = Object.keys(getters).reduce((acc, it) => {
    Object.defineProperty(acc, it, {
      enumerable: true,
      get: createMemoizedGetter(it, getters, getters[ it ])
    })
    return acc
  }, {})

  Object.defineProperty(proto, 'copy', {
    enumerable: false,
    writable: false,
    value: createCopier(numberOfGetters)
  })

  Object.defineProperty(initialState, '__computationsLeft__', {
    enumerable: false,
    writable: true,
    value: numberOfGetters
  })

  initialState.__proto__ = proto
  return initialState
}
